import { render, staticRenderFns } from "./LinkedInEmbed.vue?vue&type=template&id=3415124b"
import script from "./LinkedInEmbed.vue?vue&type=script&lang=js"
export * from "./LinkedInEmbed.vue?vue&type=script&lang=js"
import style0 from "./LinkedInEmbed.vue?vue&type=style&index=0&id=3415124b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports